// These are routes shared between SSR and SPA
export { processNavigationParams } from '../src/routes/processNavigationParams';
export { getSpaceOverviewRoute } from '../src/routes/SpaceOverviewRoute';
export { getCompanyHubRoute } from '../src/routes/company-hub/CompanyHubRoute';
export { getCompanyHubEditRoute } from '../src/routes/company-hub/CompanyHubEditRoute';
